const GET_ITEM_AND_ORDER_LEVEL_APPROVAL = 'GET_ITEM_AND_ORDER_LEVEL_APPROVAL';
const SET_IS_ITEM_AND_ORDER_LEVEL_APPROVAL = 'SET_IS_ITEM_AND_ORDER_LEVEL_APPROVAL';
const SET_REQUISITION_APPROVAL_DATA = 'SET_REQUISITION_APPROVAL_DATA'

const GET_APPROVER_ACTIONS_DATA = 'GET_APPROVER_ACTIONS_DATA';
const SET_REQUEST_APPROVER_ACTIONS_DATA = 'SET_REQUEST_APPROVER_ACTIONS_DATA';
const SET_QUANTITY_APPROVER_ACTIONS_DATA = 'SET_QUANTITY_APPROVER_ACTIONS_DATA';

const GET_CAPITAL_LEASE_EXPENDITURE_DATA = 'GET_CAPITAL_LEASE_EXPENDITURE_DATA';
const SET_CAPITAL_LEASE_EXPENDITURE_DATA = 'SET_CAPITAL_LEASE_EXPENDITURE_DATA';

export
{
    GET_ITEM_AND_ORDER_LEVEL_APPROVAL,
    SET_IS_ITEM_AND_ORDER_LEVEL_APPROVAL,
    GET_APPROVER_ACTIONS_DATA,
    SET_REQUEST_APPROVER_ACTIONS_DATA,
    GET_CAPITAL_LEASE_EXPENDITURE_DATA,
    SET_CAPITAL_LEASE_EXPENDITURE_DATA,
    SET_REQUISITION_APPROVAL_DATA,
    SET_QUANTITY_APPROVER_ACTIONS_DATA
};
